<template>
    <div class="custom-input-text flex align-items-center gap-2 relative" :style="'width: ' + width + 'px;'">
        <CustomLabel :name="name" :required="required" :label="label"/>
        <InputText :id="name + '-prefix'" type="text" :value="blockedValue"
            disabled class="p-inputtext p-component" style="width: 15%;"
        />
        <InputText :id="name" type="text" v-model="internalSuffix" :disabled="disabled"
            :placeholder="computedPlaceholder" :maxlength="maxLength"
            :class="computedClasses" @input="handleChange" @blur="handleBlur" :rules="rules"
            :dir="dir" style="width: 85%;"/>
        <CustomValidationMessage :errorMessage="errorMessage" />
        <CustomValidationMessage :errorMessage="customErrorMessage" />
    </div>
</template>

<script>
import InputText from "primevue/inputtext";
import Tooltip from "primevue/tooltip";
import {useField} from "vee-validate";
import CustomLabel from "./inner/CustomLabel";
import CustomValidationMessage from "./inner/CustomValidationMessage";
import {watch} from 'vue';

export default {
    name: "CustomInputTextSuffix",

    props: {
        countries: {
            type: Array,
        },
        name: {
            type: String,
        },
        label: {
            type: String,
        },
        width: {
            type: String,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: "",
        },
        noPlaceholder: {
            type: Boolean,
            default: false,
        },
        rules: undefined,
        modelValue: null,
        customErrorMessage: {
            type: String,
            default: "",
        },
        maxLength: {
            type: Number,
            default: null,
        },
        dir: {
            type: String,
            default: "",
        },
        countryId: {
            type: Number,
            default: null,
        }
    },

    data() {
        return {
            internalSuffix: this.modelValue || '',
            blockedValue: '',
        };
    },

    setup(props) {
        const {
            value: inputValue,
            errorMessage,
            handleBlur,
            handleChange,
            meta,
            setValue
        } = useField(props.name, props.rules, {
            initialValue: props.modelValue || '',
            validateOnInput: false,
            validateOnChange: false,
        });

        watch(
            () => props.modelValue,
            (newValue) => {
                setValue(newValue);
            },
            { immediate: true }
        );


        return {
            handleChange,
            handleBlur,
            errorMessage,
            inputValue,
            meta,
        };
    },

    emits: ["update:modelValue"],

    directives: {
        tooltip: Tooltip,
    },

    methods: {
        updateBlockedValue() {
            if (!this.internalSuffix || this.internalSuffix.trim() === '') {
                this.blockedValue = '';
                return;
            }

            const country = this.countries?.find(c => c.id === this.countryId);

            if (!country) {
                this.blockedValue = '';
                return;
            }

            this.blockedValue = country.local ? 'L' : 'F';
        },
        getFullSuffix() {
            return this.blockedValue + this.internalSuffix === '' ? null : this.blockedValue + this.internalSuffix;
        },
    },

    watch: {
        modelValue(newVal) {
            this.internalSuffix = newVal || '';
            this.updateBlockedValue();
        },

        internalSuffix() {
            this.$emit('update:modelValue', this.internalSuffix);
            this.updateBlockedValue();
        },

        countryId() {
            this.updateBlockedValue();
        },
    },

    mounted() {
        this.updateBlockedValue();
    },

    computed: {
        internalValue: {
            get() {
                return this.inputValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        },

        computedPlaceholder() {
            if (this.noPlaceholder) return "";
            if (this.placeholder === "") return this.$t('message.inputs.inputTextPlaceholder');
            else return this.placeholder;
        },

        computedClasses() {
            return this.errorMessage ? "p-invalid" : "";
        },
    },

    components: {InputText, CustomLabel, CustomValidationMessage},
};
</script>

<style scoped lang="scss">
</style>
